export default "__VITE_ASSET__BVCHi68h__"